import { z } from 'zod'
import { EncounterCodeNextUpdate, SyncStrategy } from '@fusion-advantage/formlib'
import { CancelReason, CodeNext } from '@fusion-advantage/backcompat'
import { SyncSliceState } from '../syncSlice'

export interface DeviceToCloudSyncInfo {
	// uniquely identifies the browser or app installation
	ClientId: string
	SyncStrategy: SyncStrategy
	// more client details
	IosVersion: number|null
	BuildNumber: number|null
	JsBundle: number|null
	// specifies that the client already has additional imports queued up
	// for this encounter
	AdditionalPendingForEncounter?: boolean
	// ...and here's the whole sync state for debugging purposes
	SyncState: SyncSliceState
}

//
//
//  SYNC ITEM
//

export type DeviceToCloudSyncItemOk = {
	encounterGuid: string
	nextCodeNext: CodeNext
} | null

//
//
//  ENCOUNTER STATUS
//

export interface DeviceToCloudEncounterStatusBody {
	FormResponse: {
		Encounter: {
			SubmittingUserID?: string
			ClientDate: string
			ClientDateTime: string
			Location: string|null
			Encounter_GUID: string
			CodeNext: CodeNext
			CancelReason?: CancelReason
		}
	}
}

export const encounterCodeNextUpdateToEncounterStatusBody = (update: EncounterCodeNextUpdate): DeviceToCloudEncounterStatusBody => {
	return {
		FormResponse: {
			Encounter: {
				SubmittingUserID: update.SubmittingUserID,
				ClientDate: update.ClientDate,
				ClientDateTime: update.ClientDateTime,
				Location: update.Location,
				Encounter_GUID: update.EncounterGUID,
				CodeNext: update.CodeNext,
				CancelReason: update.CancelReason,
			}
		}
	}
}

//
//
//  FILE
//

export const ZDeviceToCloudUploadFileBody = z.object({
	SasUrl: z.string()
})
export type DeviceToCloudUploadFileBody = z.infer<typeof ZDeviceToCloudUploadFileBody>
